<template>
    <ui-report-panel title="Open Defects" class="md:col-span-6 bg-gray-50" :fetch="fetch">
        <template #actions>
            <div class="flex items-baseline space-x-2">
                <span class="text-xs font-semibold text-gray-500">Currently Open</span>
                <span class="relative flex h-2 w-2">
                    <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
                    <span class="relative inline-flex rounded-full h-2 w-2 bg-blue-500"></span>
                </span>
            </div>
        </template>
        <template #default="{ report }">
            <div v-if="report && report.length > 0" class="divide-y divide-gray-200 border-t border-gray-200">
                <a class="block px-6 py-5 hover:bg-blue-50" v-for="defect in report" :key="defect.id" :href="defect._links.frontend.view">
                    <div class="flex items-center">
                        <h2 class="flex-1 text-sm font-medium text-gray-900">
                            <span v-text="defect.id"></span>
                            <span> • </span>
                            <a href="#" class="hover:underline hover:text-gray-900" v-text="defect.package_name"></a>
                        </h2>
                        <p class="ml-2 text-xs text-gray-500 truncate" v-text="defect.opened_at"></p>
                    </div>
                    <p class="mt-1 text-sm text-gray-500 truncate">
                        Opened {{ defect.opened_for }}
                    </p>
                </a>
            </div>
            <div v-else class="px-4 py-8 text-center text-gray-400 border-t border-gray-200">
                There's currently no opened defect.
            </div>
        </template>
    </ui-report-panel>
</template>

<script>
import { Defect } from '@models'

export default {
    methods: {
        async fetch () {
            return await Defect.allOpened()
        },
    },
}
</script>
